import { QuoteService } from "./quote-service";

export class ServiceLine {
    public code?: string;
    public existingQuoteService?: QuoteService;
    public renewalQuoteService?: QuoteService;
    public newQuoteService?: QuoteService;
    public appliedPrice?: string;
    public appliedPriceColor?: string;
}
